import React, {useEffect, useRef} from "react";
import styled from "@emotion/styled";
import {alertShowState, alertState} from "../../../atom/common";
import {useRecoilValue, useSetRecoilState} from "recoil";

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1001;
`;

const Container = styled.div`
    background: white;
    padding: 24px;
    border-radius: 14px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: fit-content;
    max-width: 400px;
    min-width: 300px;
    text-align: center;
`;

const ButtonBox = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 24px;
    
    button {
        max-width: 150px;
    }
`;

const ConfirmBtn = styled.button`
    flex: 1;
    padding: 12px 0;
    border-radius: 14px;
    border: none;
    background-color: ${({theme}) => theme.background[3]};
    color: ${({theme}) => theme.color[5]};
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;

    &:hover {
        opacity: 0.9;
    }
`;
const CancelBtn = styled.button`
    flex: 1;
    padding: 12px 0;
    border-radius: 14px;
    border: none;
    background-color: #a2a2a2;
    color: ${({theme}) => theme.color[5]};
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;

    &:hover {
        opacity: 0.9;
    }
`;
const Content = styled.div`
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5;
    color: ${({theme}) => theme.color[1]};
    white-space: pre-wrap;
`;


export default function Alert() {
    const {message, confirm, cancel} = useRecoilValue(alertState);
    const setShow = useSetRecoilState(alertShowState);

    const ref = useRef<HTMLDivElement>(null);

    const onConfirm = () => {
        setShow(false);
        if (confirm) confirm();
    }

    const onCancel = () => {
        setShow(false);
        if (cancel) cancel();
    }

    useEffect(() => {
        ref.current?.focus();
    }, []);

    return (
        <Overlay>
            <Container>
                <Content tabIndex={0} ref={ref}>{message}</Content>
                <ButtonBox>
                    {cancel && <CancelBtn onClick={onCancel}>취소</CancelBtn>}
                    <ConfirmBtn onClick={onConfirm}> 확인</ConfirmBtn>
                </ButtonBox>
            </Container>
        </Overlay>
    )
}
